"use client";

export const convertToNormalText = (text: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");
  return doc.documentElement.textContent;
};
